import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getModuleTemplatesListByTagId } from "../api/getModuleTemplatesListByTagId";
import { getPageModulesByTagId } from "../api/getPageModulesByTagId";
import { ModuleWithPagePath } from "../types";

const QUERY_KEY = "moduleList-by-tagId";

export const useModuleListByTagIdQuery = (tagId?: string | null) => {
  return useQuery({
    queryKey: [QUERY_KEY, tagId],
    queryFn: async () => {
      if (!tagId) {
        return [];
      }
      const [moduleTemplates = [], pageModules = []] = await Promise.all([
        getModuleTemplatesListByTagId(tagId),
        getPageModulesByTagId(tagId),
      ]);

      return [...moduleTemplates, ...pageModules] as ModuleWithPagePath[];
    },
    enabled: !!tagId,
  });
};

export const invalidateModuleListByTagIdQuery = (tagId?: string | null) => {
  return queryClient.invalidateQueries({ queryKey: [QUERY_KEY, tagId] });
};

export const invalidateEntireModuleListQuery = () => {
  return queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
};
